import * as _ from "lodash";
import { IconButton, TextField } from "office-ui-fabric-react/lib-commonjs";
import { TeachingBubble, DirectionalHint } from "office-ui-fabric-react";
import * as React from "react";
import { Component, Fragment } from "react";
import { SubjectItem } from "./OnboardSubjectMergePage/SubjectItem";
import SubjectMergeCard from "./SubjectMergeCard";

export interface RenameSubjectCardProps {
    className?: string;
    subjectItem: SubjectItem;
    onSubjectRenamed: (SubjectItem: SubjectItem, newName: string) => void;
}

interface RenameSubjectCardState {
    isEditing: boolean;
    newName?: string;
    teachingBubbleVisible: boolean;
}

export default class RenameSubjectCard extends Component<RenameSubjectCardProps, RenameSubjectCardState>
{

    constructor(props: Readonly<RenameSubjectCardProps>) {
        super(props);

        this.state = {
            isEditing: false,
            newName: undefined,
            teachingBubbleVisible: false
        }
    }

    public componentDidMount() {
    }

    private onEditClicked() {
        this.setState({
            isEditing: true,
            newName: this.props.subjectItem.name
        });
    }

    private onCancelClicked() {
        this.setState({
            isEditing: false,
            newName: undefined
        });
    }

    private onSaveClicked() {
        if (this.state.newName != undefined) {
            this.props.onSubjectRenamed(this.props.subjectItem, this.state.newName);
            this.setState({
                isEditing: false,
                newName: undefined
            });
        }
    }

    private toggleTeachingBubbleVisibilty() {
        this.setState(prevState => ({
            teachingBubbleVisible: !prevState.teachingBubbleVisible
        }));
    }

    public render() {
        const sortedMergedSubjects = _.sortBy([...this.props.subjectItem.mergedSubjects], ["subjectCode"]);
        const mergedSubjectsListItems = sortedMergedSubjects.map((mergedSubject) => {
            return (<li key={mergedSubject.subjectCode}>{mergedSubject.subjectName
                ? `${mergedSubject.subjectName} - ${mergedSubject.subjectCode}`
                : mergedSubject.subjectCode} </li>);
        });
        const mergedSubjectCount = this.props.subjectItem.mergedSubjects.length > 0 ? <span className={"subject-card__merge-count"} onClick={() => this.toggleTeachingBubbleVisibilty()}>{this.props.subjectItem.mergedSubjects.length} Merged Subjects</span> : null;

        const subjectCardHeader = (
            <Fragment>
                <span className={"flex-column flex-item--flex-1"}>
                    <span>{this.props.subjectItem.name}</span>
                    <span className={"subject-card__subject-code"}>
                        {this.props.subjectItem.code}
                    </span>
                    {mergedSubjectCount}
                </span>
                <IconButton
                    className={"m-left-auto"}
                    iconProps={{ iconName: "Edit" }}
                    title="Rename"
                    ariaLabel="Rename"
                    onClick={() => this.onEditClicked()} />
            </Fragment>
        );

        const subjectCardEditing = (
            <Fragment>
                <span className={"flex-column flex-item--flex-1"}>
                    <TextField
                        className="flex-item--flex-1 m-right-1rem"
                        disabled={false}
                        value={this.state.newName}
                        onChange={(e, v) => this.setState({ newName: v! })}
                        required={false} />
                    <span className={"subject-card__subject-code"}>
                        {this.props.subjectItem.code}
                    </span>
                    {mergedSubjectCount}
                </span>


                <IconButton
                    className={"m-left-auto"}
                    iconProps={{ iconName: "Clear" }}
                    title="Cancel"
                    ariaLabel="Cancel"
                    onClick={() => this.onCancelClicked()} />

                <IconButton
                    className={"m-left-auto"}
                    iconProps={{ iconName: "Accept" }}
                    title="Accept"
                    ariaLabel="Accept"
                    onClick={() => this.onSaveClicked()} />

            </Fragment>
        );

        const card = (
            <div id={SubjectMergeCard.getIdForSubjectItem(this.props.subjectItem)}
                className={"card card--padded card--margin-small flex-row flex--align-items-center"}>
                {this.state.isEditing ? subjectCardEditing : subjectCardHeader}
            </div>
        );

        const teachingBubble = (
            <TeachingBubble
                calloutProps={{ directionalHint: DirectionalHint.bottomCenter }}
                onDismiss={() => this.toggleTeachingBubbleVisibilty()}
                target={"#" + SubjectMergeCard.getIdForSubjectItem(this.props.subjectItem)}
                isWide={true}
                closeButtonAriaLabel="Close">
                Merged Subjects
                <ul>
                    {mergedSubjectsListItems}
                </ul>
            </TeachingBubble>
        );

        return (
            <Fragment>
                {card}
                {this.state.teachingBubbleVisible ? teachingBubble : null}
            </Fragment>
        );
    }
}